import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const DateView = ({value}) => {

    const date = dayjs(value);
    
    const jour = date.format('DD'); 
    
    const mois = date.format('MM'); 

    const annee = date.format('YYYY')
    
    return (
        <div>
            <Row>
                <Col span={16} style={{color:"#5F6368", fontSize:13}}> <span style={{marginRight:14}}>JJ</span>  <span style={{marginRight:14}}>MM</span>  <span>YYYY</span> </Col> 
                <Col span={16} style={{marginTop:8, fontSize:15}}> <span style={{marginRight:8}}>{jour}</span>/<span style={{marginRight:8, marginLeft:8}}>{mois}</span>/<span style={{marginLeft:8}}>{annee}</span></Col>
            </Row>
        </div>
    );
};

export default DateView;